module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-01@2x.72be04f0.jpg";